module.exports = __webpack_public_path__ + "img/1729144864977-IMG_4676.jpeg.87d985f2.webp";